document.addEventListener("DOMContentLoaded", function() {
  // Cibler toutes les sections accordéon
  document.querySelectorAll(".accordeon-custom").forEach(function(section) {
    const sectionId = section.getAttribute("data-section-id");
    const accordionItems = section.querySelectorAll(`#accordion-${sectionId} .accordion-item`);

    accordionItems.forEach(item => {
      const toggle = item.querySelector(".accordion-toggle");

      toggle.addEventListener("click", function() {
        // Fermer tous les autres accordéons dans la même section
        accordionItems.forEach(otherItem => {
          const otherIcon = otherItem.querySelector(".accordion-icon");
          const otherContent = otherItem.querySelector(".accordion-content");

          if (otherItem !== item) {
            otherItem.classList.remove("active");
            otherContent.style.maxHeight = null;
            otherIcon.textContent = "+"; // Remettre l'icône à "+"
          }
        });

        // Basculer l'état de l'accordéon actuel
        const content = item.querySelector(".accordion-content");
        const icon = item.querySelector(".accordion-icon");

        if (item.classList.contains("active")) {
          item.classList.remove("active");
          content.style.maxHeight = null;
          icon.textContent = "+"; // Remettre l'icône à "+"
        } else {
          item.classList.add("active");
          content.style.maxHeight = content.scrollHeight + "px";
          icon.textContent = "-"; // Changer l'icône en "-"
        }
      });
    });
  });
});